<template>
	<v-footer
		id="layout-core-footer"
		app
		fixed
		inset
		height="64"
		color="white"
		elevation="2"
	>
		<v-container fluid>
			<v-row align="center" no-gutters>
				<v-col class="text-center mb-sm-0 mb-5" cols="auto">
					©{{ date.getUTCFullYear() }} Asset Inventories, Inc. All
					rights reserved.
				</v-col>
				<v-spacer class="hidden-sm-and-down" />
				{{ applicationVersion }}
				<v-col class="d-none" cols="12" md="auto">
					<v-btn text>Clean server cache</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
import appVersion from '../../utils/appVersionUtils';
export default {
	name: 'LayoutFooter',

	data: () => ({
		date: new Date(),
		applicationVersion: appVersion.getVersion(),
		links: [
			{
				href: '#',
				text: 'Creative Tim',
			},
			{
				href: '#',
				text: 'About Us',
			},
			{
				href: '#',
				text: 'Blog',
			},
			{
				href: '#',
				text: 'Licenses',
			},
		],
	}),
};
</script>

<style></style>
